var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExerciseGrammar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_203_4854)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9397 3H16.0603C18.509 2.99999 20.4285 2.99998 21.9514 3.16497C23.5054 3.33334 24.7646 3.6831 25.8397 4.4642C26.4905 4.93708 27.0629 5.50945 27.5358 6.16031C28.3169 7.23541 28.6667 8.49459 28.835 10.0486C29 11.5715 29 13.4909 29 15.9395V16.0604C29 18.509 29 20.4285 28.835 21.9514C28.6667 23.5054 28.3169 24.7646 27.5358 25.8397C27.0629 26.4905 26.4905 27.0629 25.8397 27.5358C24.7646 28.3169 23.5054 28.6667 21.9514 28.835C20.4285 29 18.5091 29 16.0605 29H15.9396C13.491 29 11.5715 29 10.0486 28.835C8.49459 28.6667 7.23541 28.3169 6.16031 27.5358C5.50945 27.0629 4.93708 26.4905 4.4642 25.8397C3.6831 24.7646 3.33334 23.5054 3.16497 21.9514C2.99998 20.4285 2.99999 18.509 3 16.0603V15.9397C2.99999 13.491 2.99998 11.5715 3.16497 10.0486C3.33334 8.49458 3.6831 7.23541 4.4642 6.16031C4.93708 5.50945 5.50945 4.93708 6.16031 4.4642C7.23541 3.6831 8.49458 3.33334 10.0486 3.16497C11.5715 2.99998 13.491 2.99999 15.9397 3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9397 3H16.0603C18.509 2.99999 20.4285 2.99998 21.9514 3.16497C23.5054 3.33334 24.7646 3.6831 25.8397 4.4642C26.4905 4.93708 27.0629 5.50945 27.5358 6.16031C28.3169 7.23541 28.6667 8.49459 28.835 10.0486C29 11.5715 29 13.4909 29 15.9395V16.0604C29 18.509 29 20.4285 28.835 21.9514C28.6667 23.5054 28.3169 24.7646 27.5358 25.8397C27.0629 26.4905 26.4905 27.0629 25.8397 27.5358C24.7646 28.3169 23.5054 28.6667 21.9514 28.835C20.4285 29 18.5091 29 16.0605 29H15.9396C13.491 29 11.5715 29 10.0486 28.835C8.49459 28.6667 7.23541 28.3169 6.16031 27.5358C5.50945 27.0629 4.93708 26.4905 4.4642 25.8397C3.6831 24.7646 3.33334 23.5054 3.16497 21.9514C2.99998 20.4285 2.99999 18.509 3 16.0603V15.9397C2.99999 13.491 2.99998 11.5715 3.16497 10.0486C3.33334 8.49458 3.6831 7.23541 4.4642 6.16031C4.93708 5.50945 5.50945 4.93708 6.16031 4.4642C7.23541 3.6831 8.49458 3.33334 10.0486 3.16497C11.5715 2.99998 13.491 2.99999 15.9397 3Z",
    stroke: "url(#paint0_linear_203_4854)",
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3334 8.33333C11.3084 8.33333 9.66675 9.97495 9.66675 12V13.3333C9.66675 13.8856 10.1145 14.3333 10.6667 14.3333C11.219 14.3333 11.6667 13.8856 11.6667 13.3333V12C11.6667 11.0795 12.4129 10.3333 13.3334 10.3333H15.0001V21.6667H13.3334C12.7811 21.6667 12.3334 22.1144 12.3334 22.6667C12.3334 23.2189 12.7811 23.6667 13.3334 23.6667H18.6667C19.219 23.6667 19.6667 23.2189 19.6667 22.6667C19.6667 22.1144 19.219 21.6667 18.6667 21.6667H17.0001V10.3333H18.6667C19.5872 10.3333 20.3334 11.0795 20.3334 12V13.3333C20.3334 13.8856 20.7811 14.3333 21.3334 14.3333C21.8857 14.3333 22.3334 13.8856 22.3334 13.3333V12C22.3334 9.97495 20.6918 8.33333 18.6667 8.33333H13.3334Z",
    fill: "url(#paint1_linear_203_4854)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_203_4854",
    x: -21.5,
    y: -21.5,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_203_4854"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_203_4854",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_4854",
    x1: 3,
    y1: 3,
    x2: 29.0132,
    y2: 28.9868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_203_4854",
    x1: 16.1067,
    y1: 26.9333,
    x2: 36.8108,
    y2: 10.1678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerciseGrammar);
export default __webpack_public_path__ + "static/media/exercise-grammar.dc04d37d2cae15ffba5ad7bae9ef200b.svg";
export { ForwardRef as ReactComponent };